import {
  clearCustomer,
  loadCustomer,
  toggleChangePasswordModel,
  toggleEditModel,
} from "./action";
import { logout, signedIn } from "ccui-framework";
import { setCustomerProfile } from "../../thunks/customerInfo";
import {
  FADE_IN_CARD_ADDED,
  OPEN_ERROR_BOX,
  SET_NOTIFICATION_MSG,
} from "../../constants/actionTypes";

export const getCustomer =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const profileData = await remote(
        "get",
        `v3/customers`,
        {},
        "get customer",
        dispatch
      );

      if (!profileData || profileData.message) {
        throw profileData.message;
      }

      if (!profileData.customer.bulkSeller) {
        history.push("/security/login/");
        return;
      }

      dispatch(signedIn());
      dispatch(loadCustomer(profileData.customer));
      dispatch(setCustomerProfile(profileData)); // for existing pages

      // go to referrer first
      // go to pathname second
      // default to "/new-order/enter-cards"
      history.push(
        history?.location?.state?.referrer
          ? history?.location?.state?.referrer
          : history?.location?.pathname
          ? history?.location?.pathname
          : "/new-order/enter-cards"
      );
    } catch (error) {
      // console.log(error);
      dispatch(logout());
      dispatch(clearCustomer());
    }
  };

export const updateAddressAndPhoneNum =
  (editedCustomerInfo) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const { customer } = getState();
      const [phones, address] = await Promise.all([
        remote(
          "post",
          "v3/customers/phones",
          {
            customerId: editedCustomerInfo.id,
            phone: {
              number: editedCustomerInfo.phone,
            },
          },
          "updated customer phone",
          dispatch
        ),
        remote(
          "post",
          "v3/customers/addresses",
          {
            customerId: editedCustomerInfo.id,
            address: {
              firstname: customer.firstname,
              lastname: customer.lastname,
              street: editedCustomerInfo.street,
              street2: editedCustomerInfo.street2 || "",
              city: editedCustomerInfo.city,
              state: editedCustomerInfo.state,
              postcode: editedCustomerInfo.zip,
            },
          },
          "updated customer addresses",
          dispatch
        ),
      ]);

      if (phones.message) {
        throw phones;
      }

      if (address.message) {
        throw address;
      }

      dispatch(getCustomer());
      dispatch(toggleEditModel());
    } catch (error) {
      console.log(error);
      dispatch({
        type: OPEN_ERROR_BOX,
        payload: {
          title: "Update profile error",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        },
      });
      dispatch(toggleEditModel());
    }
  };

export const changePassword =
  (newPassword, oldPassword) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const resetPasswordAccount = await remote(
        "put",
        "v3/customers/password/change",
        { customer: { oldPassword, newPassword } },
        "resetting your password",
        dispatch
      );

      if (resetPasswordAccount.message) {
        throw resetPasswordAccount;
      }
      dispatch(toggleChangePasswordModel());
      dispatch({ type: SET_NOTIFICATION_MSG, payload: "Password Changed" });
      dispatch({ type: FADE_IN_CARD_ADDED });
    } catch (error) {
      dispatch(toggleChangePasswordModel());
      dispatch({
        type: OPEN_ERROR_BOX,
        payload: {
          title: "Update profile error",
          message:
            "We are sorry. There was a problem connecting to the server. Please try again. If you are still having issues, please reach out to support@cardcash.com. Thank you.",
        },
      });
      dispatch({ type: CHANGE_PASSWORD_ERR_MSG, payload: error.messaged });
    }
  };
